// Mirrors the backend enum com.trajectx.trajectory.ScoreResolution. Kept in
// its own import-free module so TrajectoryService and
// TrajectoryBlueprintService can both use it without an import cycle.
export enum ScoreResolution {
	// The newest snapshot that carries a score wins; a later score-less
	// "behaald" pass does not hide it. Today's behaviour and the default.
	LAST_SCORE = "LAST_SCORE",
	// The newest snapshot marked achieved or offered without a score is the
	// final state, even when an earlier score exists.
	TRAILING_ACHIEVED = "TRAILING_ACHIEVED"
}
